
export type keyCodeItem = {
  key: string;
  code: string;
};
export type keyCodeValueItem = {
  key: string;
  code: string;
  value: string;
  country: string;
};
/**
 * 国际区号
 */
export const areaCodeDataList: keyCodeValueItem[] = [
  {
    key: '+86', // 中国
    code: '+86',
    value: '中国大陆',
    country: 'CN',
  },
  {
    key: '+1a',  // 美国
    code: '+1',
    country: 'US',
    value: '美国'
  },
  {
    key: '+1',  // 加拿大
    code: '+1',
    country: 'CA',
    value: '加拿大'
  },
  {
    key: '+44', // 英国
    code: '+44',
    country: 'GB',
    value: '英国'
  },
  {
    key: '+60', // 马来西亚
    code: '+60',
    country: 'MY',
    value: '马来西亚'
  },
  {
    key: '+61', // 澳大利亚
    code: '+61',
    country: 'AU',
    value: '澳大利亚'
  },
  {
    key: '+62', // 印度尼西亚
    code: '+62',
    country: 'ID',
    value: '印度尼西亚'
  },
  {
    key: '+63', // 印度尼西亚
    code: '+63',
    country: 'PH',
    value: '菲律宾'
  },
  {
    key: '+65', // 新加坡
    code: '+65',
    country: 'SG',
    value: '新加坡'
  },
  {
    key: '+66', // 泰国
    code: '+66',
    country: 'TH',
    value: '泰国'
  },
  {
    key: '+81', // 日本
    code: '+81',
    country: 'JP',
    value: '日本'
  },
  {
    key: '+82', // 韩国
    code: '+82',
    country: 'KR',
    value: '韩国'
  },
  {
    key: '+84', // 越南
    code: '+84',
    country: 'VN',
    value: '越南'
  },
  {
    key: '+852',  // 香港地区
    code: '+852',
    country: 'HK',
    value: '香港地区'
  },
  {
    key: '+853',  // 澳门地区
    code: '+853',
    country: 'MO',
    value: '澳门地区'
  },
  {
    key: '+886',  // 台湾地区
    code: '+886',
    country: 'TW',
    value: '台湾地区'
  },
  {
    key: '+855',  // 柬埔寨
    code: '+855',
    country: 'HKM',
    value: '柬埔寨'
  },
  {
    key: '+971', // 英国
    code: '+971',
    country: 'UAE',
    value: '阿联酋'
  },
];

/**
 * 选择语言
 */
export const languageSelectList = [
  {
    value: '简体中文',
    languageName: '简体中文',
    languageCode: 'CN',
    captchaLanguage: 'zh-cn'
  },
  {
    value: '繁體中文',
    languageName: '繁体中文',
    languageCode: 'HK-TW',
    captchaLanguage: 'zho-tw'
  },
  {
    value: 'English',
    languageName: '英文',
    languageCode: 'EN',
    captchaLanguage: 'eng'
  },
  {
    value: 'Tiếng Việt',
    languageName: '越南文',
    languageCode: 'VN',
    captchaLanguage: 'vie'
  },
  {
    value: '日本語',
    languageName: '日文',
    languageCode: 'JP',
    captchaLanguage: 'jpn'
  },
  {
    value: '한국인',
    languageName: '韩文',
    languageCode: 'KR',
    captchaLanguage: 'kor'
  },
  {
    value: 'ไทย',
    languageName: '泰文',
    languageCode: 'TH',
    captchaLanguage: 'tha'
  },
  {
    value: 'Bahasa Indonesia',
    languageName: '印尼文',
    languageCode: 'ID',
    captchaLanguage: 'ind'
  },
  {
    value: 'Français',
    languageName: '法语',
    languageCode: 'FR',
    captchaLanguage: 'fra'
  },
  {
    value: 'ភាសាខ្មែរ',
    languageName: '高棉语',
    languageCode: 'KM',
    captchaLanguage: 'khm'
  },
];



